// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_2XgC5","dropdown":"index_dropdown_26V27","avatar":"index_avatar_2hXvw","menuIcon":"index_menuIcon_3_VoQ"};